import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router/lib/route';

export const routes = {
    Create: AsyncPageRender(() => pageModule(import('./Create'))),
    Index: AsyncPageRender(() => pageModule(import('./Index'))),
    View: AsyncPageRender(() => pageModule(import('./View'))),
    Detail: AsyncPageRender(() => pageModule(import('./Details'))),
};

function Router() {
    return (
        <>
            <Route
                name={'RedoRequest.Create'}
                exact
                path={'/redo-requests/create'}
                component={ProtectedRoute(routes.Create)}
            />

            <Route
                name={'RedoRequest.List'}
                exact
                path={'/redo-requests/:tab'}
                component={ProtectedRoute(routes.Index)}
            />

            <Route
                name={'RedoRequest.Detail'}
                exact
                path={'/redo-request/:id/view/:detailId'}
                component={ProtectedRoute(routes.Detail)}
            />

            <Route
                name={'RedoRequest.View'}
                exact
                path={'/redo-request/:id/view'}
                component={ProtectedRoute(routes.View)}
            />
        </>
    );
}

export default Router;
